const isBase64 = (string) => {
    try {
        return atob(string);
    } catch {
        return false;
    }
};

export default isBase64;
